
import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

import {ClassRecordTechniqueComponent} from './ClassRecordTechniqueComponent.js';

export class ClassRecordTechniquesEditor {
	constructor(parentEl, classRecordId, model, techniquesArray) {
		this.parentEl = parentEl;
		this.classRecordId = classRecordId;
		this.model = model;

		this.model.Listeners.add( (msg, dat) => {
			switch(msg) {
				case 'technique_added':
					let c = new ClassRecordTechniqueComponent(this.model, dat, false);
					this.$.techniquesList.appendChild(c.render());
					break;
				case 'technique_removed':
					// Ignore for now - the component will remove itself
					break;
				default:
					console.error('Unhandled ClassRecordTechniquesModel message: ' + msg);
					break;
			}
			this.setTechniquesCount();
		});
		[this.el, this.$] = DojoTemplates('ClassRecordTechniquesEditor');

		this.$.techniqueEntry.addEventListener(`auto-complete-entry`, evt=>{
			let technique = evt.detail.value;
			let data = evt.detail.data;
			this.model.addTechnique({"Name": technique});
			return false;
		});


		this.parentEl.appendChild(this.el);
	}
	render() {
		return this.el;
	}
	setTechniquesCount() {
		let evt = new CustomEvent(`dojo-tab-title-set`,{
			bubbles: true,
			composed: true,
			cancelable: true,
			detail: {
				tab: `techniques`,
				title: `Techniques (${this.model.count()})`,
			}
		});
		this.el.dispatchEvent(evt);
	}
}

window.ClassRecordTechniquesEditor = ClassRecordTechniquesEditor;